import { getNewCustomerDiscountExpiresAtUserSelect } from 'modules/training/modules/training-users/selectors/getNewCustomerDiscountExpiresAt/index.js'
import { createSelector } from 'reselect'

export const hasNewCustomerDiscountExpiresAtUserSelect = createSelector(
  getNewCustomerDiscountExpiresAtUserSelect,
  (
    newCustomerDiscountExpiresAt
  ) => {
    return !!newCustomerDiscountExpiresAt
  }
)
